import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChecklistTypeModel, FilterChecklistTypeModel } from 'src/Models/BriefingMasterModel';
import { I360Service } from 'src/Services/i360Service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-checklist-type',
  templateUrl: './checklist-type.component.html',
  styleUrls: ['./checklist-type.component.css']
})
export class ChecklistTypeComponent implements OnInit {

  tokenKey: string|null;
  isloading: boolean = false;
  PageNumber: number = 1;
  listofChecklistTypes: ChecklistTypeModel[];
  listofChecklistTypesExport: ChecklistTypeModel[];
  filterModel = new FilterChecklistTypeModel();

  SelectedTool: string|null;
  PageSize: number;
  isRecord: boolean = false;
  totalRecordCount: number = 0;
  checklistName: string;
  OrderBy: string;
  isAscending: boolean = false;
  upDowchecklistNameCSS: string = '';
  upDowSortOrderCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowIsArchiveCSS: string = '';
  checklistId: number = 0;
  openMenuIndex: number = -1

  constructor(private readonly i360service: I360Service,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.PageNumber = 1;
    this.PageSize = 10;
    this.OrderBy = 'SortOrder';
    this.checklistName = 'null';

    this.filterModel.PageNumber=1;
    this.filterModel.PageSize=10;
    this.filterModel.OrderBy='SortOrder';

    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Checklist');
    this.listofChecklistTypes=[];
    this.listofChecklistTypesExport=[];
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.isloading = true;
    this.GetAllChecklistTypes();
  }

  keywordFilters($event: { target: { value: string | null; }; }) {
    this.PageNumber = 1;
    this.filterModel.PageNumber=1;
    if ($event.target.value != "" && $event.target.value != null)
      this.checklistName = $event.target.value;
    else
      this.checklistName = 'null';

    this.GetAllChecklistTypes();
  }

  GetAllChecklistTypes() {
    this.isloading = true;
    this.listofChecklistTypes = [];
    if (this.checklistName == "null") this.checklistName = " ";
    this.filterModel.FilterText=this.checklistName;
    this.filterModel.IsExport=false;
    
    this.i360service.ChecklistType(this.tokenKey,this.filterModel).subscribe(
      data => {
        this.isloading = false;
        this.listofChecklistTypes = data['listOfChecklist'];
        if (this.listofChecklistTypes != null) {
          if (this.listofChecklistTypes.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofChecklistTypes[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => {
        console.log(error);
      }
    );
  }

  addChecklistType() {
    let navigation = '/admin/' + this.SelectedTool + '/checklistType/manage';
    this.router.navigate([navigation]);
  }

  updateChecklistType(checklistId) {
    let navigation = '/admin/' + this.SelectedTool + '/checklistType/manage/' + checklistId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.checklistId = id;
  }

  deleteChecklistType(checklistId) {
    this.isloading = true;
    this.i360service.DeleteChecklistType(this.tokenKey, checklistId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else
            this.showMessage("Deleted successfully", 'Success', 'success')
        }
        this.GetAllChecklistTypes();
      },
      error => { }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  pageChanged($event: any) {
    this.filterModel.PageNumber=parseInt($event.page);
    this.PageNumber = parseInt($event.page);
    this.GetAllChecklistTypes();
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "checklistName") {
        this.upDowchecklistNameCSS = 'fa fa-arrow-down';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowchecklistNameCSS = '';
        this.upDowSortOrderCSS = 'fa fa-arrow-down';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowchecklistNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsArchive") {
        this.upDowchecklistNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "checklistName") {
        this.upDowchecklistNameCSS = 'fa fa-arrow-up';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowchecklistNameCSS = '';
        this.upDowSortOrderCSS = 'fa fa-arrow-up';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowchecklistNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
        this.upDowIsArchiveCSS = '';
      }
      else if (sortBy === "IsArchive") {
        this.upDowchecklistNameCSS = '';
        this.upDowSortOrderCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowIsArchiveCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.filterModel.PageNumber=1;
    this.GetAllChecklistTypes();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportChecklist() {
    this.isloading = true;
    this.listofChecklistTypesExport = [];

    if (this.checklistName == "null") this.checklistName = " ";
    this.filterModel.FilterText = this.checklistName;
    this.filterModel.IsExport = true;

    this.i360service.ChecklistType(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.listofChecklistTypesExport = data['listOfChecklist'];
        if (this.listofChecklistTypesExport != null) {
          if (this.listofChecklistTypesExport.length > 0) {
            setTimeout(() => {
              this.DownloadChecklist();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadChecklist() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportBriefingChecklist';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportBriefingChecklist.xls");
  }
}